import React from 'react';
import Aboutcard1 from './aboutcard1'
import Aboutcard2 from './aboutcard2'
import ScrollAnimation from 'react-animate-on-scroll';
import '../../App.css';
import Skill from '../../components/progress/Skill' ;


function AboutPage() {
  return (
  


<div >   

<ScrollAnimation animateIn='fadeInDownBig' animateOnce='true'
  initiallyVisible={true}>
<Aboutcard1 />
</ScrollAnimation>


<Aboutcard2 />
<p class="heading-num">03</p>
<h1 class="heading heading--top">
SKILL SET</h1>
<ScrollAnimation animateIn='bounceInLeft' animateOnce='true'
  initiallyVisible={true}>
 <Skill />
</ScrollAnimation>  


 
 <div style={{marginBottom:'200px'}}>    
 </div>
 



</div>

                      
);
}
   


export default AboutPage;
     